import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';

import { PenaltyCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';


function MortgagePenaltyCalculator({
    disclaimer,
    showAdDisclosure,

    messageBannerCopy,
    messageBannerLinkText,
    messageBannerLinkHREF,

    className,

    ...otherProps
}) {
    return (
        <section
            className={classNames(
                'rh-max-width-75',
                'rh-pt-0_5',
                className,
            )}
            {...otherProps}
        >
            <PenaltyCalculator
                messageBannerCopy={messageBannerCopy}
                messageBannerLinkText={messageBannerLinkText}
                messageBannerLinkHREF={messageBannerLinkHREF}
            />

            <If condition={showAdDisclosure}>
                <StyledDiv
                    className={classNames(
                        'rh-my-1',
                        'rh-mx-0_5',
                    )}
                >
                    <AdvertisingDisclosure
                        size="extra-small"
                    />
                </StyledDiv>
            </If>

            <If condition={disclaimer}>
                <p
                    className={classNames(
                        'rh-mt-0_25',
                        'rh-mx-0_5',
                        'rh-text-align-center',
                        'rh-text-xs',
                    )}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: disclaimer,
                    }}
                />
            </If>
        </section>
    );
}

MortgagePenaltyCalculator.propTypes = {
    disclaimer: PropTypes.string,
    showAdDisclosure: PropTypes.bool,

    messageBannerCopy: PropTypes.string,
    messageBannerLinkText: PropTypes.string,
    messageBannerLinkHREF: PropTypes.string,

    className: PropTypes.string,
};

MortgagePenaltyCalculator.defaultProps = {
    disclaimer: undefined,
    showAdDisclosure: true,

    messageBannerCopy: undefined,
    messageBannerLinkText: undefined,
    messageBannerLinkHREF: undefined,

    className: undefined,
};

const StyledDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

MortgagePenaltyCalculator.blockKey = 'rh/mortgage-penalty-calculator';
MortgagePenaltyCalculator.requiresLayoutRow = true;
MortgagePenaltyCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgagePenaltyCalculator;
